<template>
  <div class="column is-12 container">
    <div class="columns is-variable is-1">
      <form class="content column is-12" @submit.prevent="checkForm">
        <div class="columns is-multiline is-variable is-4">
          <div class="field column" :class="'is-' + (hideFields.includes('organisation') ? '12' : '6')" v-if="!hideFields.includes('name')">
            <label class="label">{{
              $t("Contactform.Name") + (fields.name.notNull ? " *" : "")
            }}</label>
            <div class="control">
              <input
                v-model="fields.name.value"
                class="input is-medium"
                :class="{ 'is-danger': fields.name.errors.length > 0 }"
                name="name"
                type="text"
                :placeholder="$t('Contactform.Name')"
              />
            </div>
            <p class="help is-danger" v-if="fields.name.errors.length > 0">
              {{ fields.name.errors.join(", ") }}
            </p>
          </div>
          <div class="field column" :class="'is-' + (hideFields.includes('name') ? '12' : '6')" v-if="!hideFields.includes('organisation')">
            <label class="label">{{
              $t("Contactform.Organisation") +
              (fields.organisation.notNull ? " *" : "")
            }}</label>
            <div class="control">
              <input
                v-model="fields.organisation.value"
                class="input is-medium"
                :class="{ 'is-danger': fields.organisation.errors.length > 0 }"
                name="organisation"
                type="text"
                :placeholder="$t('Contactform.Organisation')"
              />
            </div>
            <p
              class="help is-danger"
              v-if="fields.organisation.errors.length > 0"
            >
              {{ fields.organisation.errors.join(", ") }}
            </p>
          </div>
          <div class="field column" :class="'is-' + (hideFields.includes('email') ? '12' : '6')" v-if="!hideFields.includes('phone')">
            <label class="label">{{
              $t("Contactform.Phone") + (fields.phone.notNull ? " *" : "")
            }}</label>
            <div class="control">
              <input
                v-model="fields.phone.value"
                class="input is-medium"
                :class="{ 'is-danger': fields.phone.errors.length > 0 }"
                name="phone"
                type="text"
                :placeholder="$t('Contactform.Phone')"
              />
            </div>
            <p class="help is-danger" v-if="fields.phone.errors.length > 0">
              {{ fields.phone.errors.join(", ") }}
            </p>
          </div>
          <div class="field column" :class="'is-' + (hideFields.includes('phone') ? '12' : '6')" v-if="!hideFields.includes('email')">
            <label class="label">{{
              $t("Contactform.Email") + (fields.email.notNull ? " *" : "")
            }}</label>
            <div class="control">
              <input
                v-model="fields.email.value"
                class="input is-medium"
                :class="{ 'is-danger': fields.email.errors.length > 0 }"
                name="email"
                type="text"
                :placeholder="$t('Contactform.Email')"
              />
            </div>
            <p class="help is-danger" v-if="fields.email.errors.length > 0">
              {{ fields.email.errors.join(", ") }}
            </p>
          </div>
          <div class="field column is-12" v-if="staff.length && !hideFields.includes('who')">
            <label class="label">{{
              $t("Contactform.Who") + (fields.who.notNull ? " *" : "")
            }}</label>
            <div class="control">
              <div
                class="select is-medium"
                :class="{ 'is-danger': fields.who.errors.length > 0 }"
                name="who"
              >
                <select v-model="fields.who.value">
                  <option selected disabled :value="null">
                    {{ $t("Contactform.WhoNoSelected") }}
                  </option>
                  <option
                    v-for="(person, idx) in staff"
                    :key="idx"
                    :value="person.ID"
                  >
                    {{ person.Name }}
                  </option>
                </select>
              </div>
            </div>
            <p class="help is-danger" v-if="fields.who.errors.length > 0">
              {{ fields.who.errors.join(", ") }}
            </p>
          </div>
          <div class="field column is-12" v-if="!hideFields.includes('message')">
            <label class="label">{{
              $t("Contactform.Message") + (fields.message.notNull ? " *" : "")
            }}</label>
            <div class="control">
              <textarea
                v-model="fields.message.value"
                class="textarea is-medium"
                :class="{ 'is-danger': fields.message.errors.length > 0 }"
                name="message"
                :placeholder="$t('Contactform.Message')"
              ></textarea>
            </div>
            <p class="help is-danger" v-if="fields.message.errors.length > 0">
              {{ fields.message.errors.join(", ") }}
            </p>
          </div>
          <div class="field column is-12" v-for="(field, k) in extra" :key="k">
            <label class="label">{{
              field.label + (field.notNull ? " *" : "")
            }}</label>
            <div class="control">
              <input
                v-model="field.value"
                class="input is-medium"
                :class="{ 'is-danger': field.errors.length > 0 }"
                :name="k"
                type="text"
                :placeholder="field.label"
              />
            </div>
            <p class="help is-danger" v-if="field.errors.length > 0">
              {{ field.errors.join(", ") }}
            </p>
          </div>
          <div class="field column is-narrow captcha-img">
            <label class="label">{{ $t("Contactform.Captcha") }}</label>
            <div class="control">
              <!-- <img @load="captchaLoaded" :src="captcaUrl +'/contactformsubmissions/captcha?v=' + captchaTime" /> -->
              <span><img v-if="captcha != ''" :src="captcha" /></span>
              <button
                type="button"
                class="input is-medium"
                @click.prevent="refreshCaptcha"
                :disabled="captchaLoading"
              >
                <font-awesome-icon
                  :key="captchaLoading"
                  :icon="icons.refresh"
                  :spin="captchaLoading"
                />
              </button>
            </div>
            <!-- <p class="help is-danger" v-if="fields.captcha.errors.length > 0">{{ fields.captcha.errors.join(', ') }}</p> -->
          </div>
          <div class="field column captcha-answer">
            <label class="label">&nbsp;</label>
            <div class="control">
              <input
                v-model="fields.captcha.value"
                class="input is-medium"
                :class="{ 'is-danger': fields.captcha.errors.length > 0 }"
                name="Captcha"
                type="text"
                :placeholder="$t('Contactform.CaptchaAnswer')"
              />
            </div>
            <p class="help is-danger" v-if="fields.captcha.errors.length > 0">
              {{ fields.captcha.errors.join(", ") }}
            </p>
          </div>
        </div>
        <div class="field is-grouped">
          <transition name="fade" mode="out-in">
            <article
              class="message is-danger"
              v-if="status === 'error'"
              :key="1"
            >
              <div class="message-body">
                <button
                  class="delete"
                  aria-label="delete"
                  @click.prevent="status = 'ready'"
                ></button>
                <span v-if="error === 'Invalid'">{{
                  $t("Contactform.ContactformInvalidCaptcha")
                }}</span>
                <span v-else>{{
                  $t("Contactform.ContactformError")
                }}</span>
              </div>
            </article>
            <article
              class="message is-success"
              v-else-if="status === 'success'"
              :key="2"
            >
              <div class="message-body">
                <button
                  class="delete"
                  aria-label="delete"
                  @click.prevent="status = 'ready'"
                ></button>
                {{ $t("Contactform.ContactformSuccess") }}
              </div>
            </article>
            <div class="control" v-else :key="3">
              <button
                type="submit"
                class="button is-primary is-medium"
                :class="{ 'is-loading': status === 'submitting' }"
              >
                {{ $t("Buttons.Submit") }}
              </button>
            </div>
          </transition>
        </div>
        <loader :loading="status === 'submitting'"></loader>
      </form>
    </div>
  </div>
</template>

<script>
import { faSyncAlt } from '@fortawesome/pro-solid-svg-icons'
import loader from '@/components/Loader.vue'

export default {
  name: 'contentform',
  props: {
    hideFields: {
      type: Array,
      default: () => []
    },
    fieldValues: {
      type: Object,
      default: () => {}
    },
    extraFields: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      icons: {
        refresh: faSyncAlt
      },
      appname: process.env.VUE_APP_NAME,
      captchaTime: new Date().getTime(),
      staff: [],
      error: '',
      captcha: '',
      captchaLoading: true,
      captchaKey: '',
      status: 'ready',
      extra: { },
      fields: {
        name: {
          value: null,
          notNull: true,
          test: false,
          message: '',
          errors: []
        },
        organisation: {
          value: null,
          notNull: true,
          test: false,
          message: '',
          errors: []
        },
        phone: {
          value: null,
          notNull: true,
          test: /[0-9]/g,
          message: this.$t('Contactform.PhoneMessage'),
          errors: []
        },
        email: {
          value: null,
          notNull: true,
          test: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          message: this.$t('Contactform.EmailMessage'),
          errors: []
        },
        who: {
          value: null,
          notNull: false,
          test: false,
          message: '',
          errors: []
        },
        message: {
          value: null,
          notNull: true,
          test: false,
          message: '',
          errors: []
        },
        captcha: {
          value: null,
          notNull: true,
          test: false,
          message: '',
          errors: []
        }
      }
    }
  },
  mounted () {
    this.refreshCaptcha()
    this.setExtraFields()
    this.setFieldValues()
  },
  components: {
    loader
  },
  computed: {
    captcaUrl () {
      return (
        '//api.' +
        this.$store.state.base +
        '/website/' +
        this.appname +
        '_' +
        this.$store.state.language
      )
    },
    content () {
      return this.activePage.Cultures[this.$store.state.language]
    },
    activePage () {
      return this.$store.state.activePage
    }
  },
  methods: {
    checkForm: function () {
      var key; var field
      var hasErrors = false
      for (key in this.fields) {
        field = this.fields[key]
        field.errors = []
        if (field.notNull && (!field.value || /^\s*$/.test(field.value))) {
          field.errors.push(this.$t('Contactform.CannotBeEmpty'))
          hasErrors = true
        } else {
          if (field.test && !field.test.test(field.value)) {
            field.errors.push(field.message)
            hasErrors = true
          }
        }
      }
      for (key in this.extra) {
        field = this.extra[key]
        field.errors = []
        if (field.notNull && (!field.value || /^\s*$/.test(field.value))) {
          field.errors.push(this.$t('Contactform.CannotBeEmpty'))
          hasErrors = true
        }
      }

      if (!hasErrors) {
        this.submitForm()
      }
    },
    refreshCaptcha: function () {
      var self = this

      if (self.error === 'Invalid') {
        return Promise.resolve()
      }

      self.captchaLoading = true
      self.fields.captcha.value = null

      return self
        .$http({
          url: self.captcaUrl + '/contactformsubmissions/captcha',
          method: 'GET',
          api: 'website',
          auth: false,
          responseType: 'blob'
        })
        .then(function (response) {
          if (response.headers && response.headers['x-request-key']) {
            self.captchaKey = response.headers['x-request-key']
          }

          var reader = new window.FileReader()
          reader.readAsDataURL(response.data)
          reader.onload = function () {
            var captchaDataUrl = reader.result
            self.captcha = captchaDataUrl
            self.captchaLoading = false
          }
        })
    },
    setExtraFields: function () {
      if (Object.keys(this.extraFields).length > 0) {
        for (var key in this.extraFields) {
          this.extra[key] = {
            value: null,
            notNull: true,
            test: false,
            message: '',
            errors: [],
            label: this.extraFields[key]
          }
        }
      }
    },
    setExtraFieldValues: function () {
      var message = ''
      for (var key in this.extra) {
        message += `\n\n${key}: ${this.extra[key].value}`
      }
      return message
    },
    setFieldValues: function () {
      var key, param
      for (key in this.fields) {
        param = this.getParameterByName(key)
        if (param) {
          this.fields[key].value = param
        }
      }
      for (key in this.extra) {
        param = this.getParameterByName(key)
        if (param) {
          this.extra[key].value = param
        }
      }
    },
    getFieldValue: function (key) {
      if (this.fields[key]) {
        if (this.fieldValues && this.fieldValues[key]) {
          return this.fieldValues[key]
        } else {
          return this.fields[key].value
        }
      } else {
        return false
      }
    },
    getParameterByName (name, url = window.location.href) {
      name = name.replace(/[[\]]/g, '\\$&')
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
      var results = regex.exec(url)
      if (!results) return null
      if (!results[2]) return ''
      return decodeURIComponent(results[2].replace(/\+/g, ' '))
    },
    submitForm: function () {
      var self = this
      self.status = 'submitting'
      var status = ''

      var data = {
        Culture: self.$store.state.language,
        Ip: '',
        UserAgent: navigator.userAgent,
        Name: self.getFieldValue('name'),
        Organization: self.getFieldValue('organisation'),
        PhoneNumber: self.getFieldValue('phone'),
        Email: self.getFieldValue('email'),
        Message: ((self.getFieldValue('message') || '') + self.setExtraFieldValues()),
        ContactWith: self.getFieldValue('who') || '00000000-0000-0000-0000-000000000000'
      }

      self
        .$http({
          method: 'POST',
          url:
            '/' +
            self.appname +
            '_' +
            self.$store.state.language +
            '/contactformsubmissions?captchaValue=' +
            self.fields.captcha.value,
          api: 'website',
          auth: false,
          data: data,
          headers: {
            'X-Request-Key': self.captchaKey
          }
        })
        .then(function (response) {
          for (var key in self.fields) {
            self.fields[key].value = null
          }
          status = 'success'
        })
        .catch(function (err) {
          self.$store.dispatch('setSnack', {
            message: err.message
          })
          self.error = ''
          if (err.response && err.response.status === 409) {
            for (let key in err.response.data) {
              const error = err.response.data[key]
              if (error.code === 'Invalid') {
                self.error = 'Invalid'
                break
              }
            }
          }
          status = 'error'
        })
        .then(function () {
          self.refreshCaptcha().then(function () {
            self.status = status
            setTimeout(function () {
              self.status = 'ready'
            }, 5000)
          })
        })
    },
    setStaff: function (staff) {
      var self = this
      self.staff = staff
    }
  },
  watch: {
    '$store.state.staff': {
      handler: function (val) {
        var self = this
        self.setStaff(val)
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

form {
  .field {
    margin-bottom: 0;
    padding-top: 0;
    .select {
      width: 100%;
      > select {
        width: 100%;
      }
    }
    &.captcha-img {
      .control {
        height: 39px;
        > span {
          display: inline-block;
          vertical-align: top;
          height: 39px;
          width: 187px;
          border-radius: 4px 0 0 4px;
          border: 1px solid #dbdbdb;
          // object-fit: cover;
          // object-position: center;
        }
        button {
          height: 39px;
          display: inline-block;
          width: 50px;
          margin-left: -1px;
          vertical-align: top;
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
          color: $grey-lighter;
          cursor: pointer;
          outline: none !important;
        }
      }
    }
  }
  @media screen and (max-width: $bp-tablet - 1px) {
    .captcha-answer {
      label {
        display: none;
      }
    }
  }
}
.control > .button[type="submit"] {
  height: 40px;
}
.message {
  width: 100%;
  font-size: 1.25rem;
  .message-body {
    position: relative;
    min-height: 40px;
    padding-bottom: calc(0.375em - 1px);
    padding-left: 0.75em;
    padding-right: 0.75em;
    padding-top: calc(0.375em - 1px);
    .delete {
      right: 0.5rem;
      position: absolute;
      top: 0.75rem;
      background-color: transparentize($danger, 0.75);
    }
  }
  &.is-success {
    .delete {
      background-color: transparentize($success, 0.75);
    }
  }
}
</style>
